import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  #root { 
    display: flex;
    flex-direction: row;
    color: #062333;
    a {
      color: #009BF2
    }
  }
`;
